var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('section',[_c('header',[_c('h2',[_vm._v("Account settings for "+_vm._s(_vm.$store.state.firstname)+" "+_vm._s(_vm.$store.state.lastname))])]),_c('EditProfileForm')],1),_c('section',[_c('DeleteAccountForm')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }